export type Category = "feature" | "improvement" | "fix" | "announcement";

export type Entry = {
  id: string;
  slug: string;
  title: string;
  summary: string;
  body: string;
  category: Category;
  published_at: string | null;
  created_at: string;
  updated_at: string;
};

export type Draft = {
  id: string | null;
  slug: string;
  title: string;
  summary: string;
  body: string;
  category: Category;
  published: boolean;
};

export const EMPTY_DRAFT: Draft = {
  id: null, slug: "", title: "", summary: "", body: "",
  category: "feature", published: false,
};

export const slugify = (s: string) =>
  s.toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);
